/**
 * 路由配置
 * 定义所有页面路由，预留模块扩展空间
 */
import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/home/Home.vue';
const routes = [
    // 一级导航 - 首页
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: { title: '首页' }
    },
    // 一级导航 - 文章（包含二级路由：列表、详情、分类筛选、标签筛选）
    {
        path: '/article',
        name: 'Article',
        component: () => import('../views/article/ArticleIndex.vue'),
        meta: { title: '文章' },
        children: [
            {
                path: '',
                name: 'ArticleList',
                component: () => import('../views/article/ArticleList.vue'),
                meta: { title: '文章列表' }
            },
            {
                path: ':id',
                name: 'ArticleDetail',
                component: () => import('../views/article/ArticleDetail.vue'),
                meta: { title: '文章详情' }
            },
            {
                path: 'category/:categoryId',
                name: 'CategoryFilter',
                component: () => import('../views/article/CategoryFilter.vue'),
                meta: { title: '分类浏览' }
            },
            {
                path: 'tag/:tagName',
                name: 'TagFilter',
                component: () => import('../views/article/TagFilter.vue'),
                meta: { title: '标签浏览' }
            }
        ]
    },
    // 一级导航 - 项目展示
    {
        path: '/projects',
        name: 'Projects',
        component: () => import('../views/project/ProjectIndex.vue'),
        meta: { title: '项目' },
        children: [
            {
                path: '',
                name: 'ProjectList',
                component: () => import('../views/article/Projects.vue'),
                meta: { title: '项目展示' }
            },
            {
                path: ':id',
                name: 'ProjectDetail',
                component: () => import('../views/project/ProjectDetail.vue'),
                meta: { title: '项目详情' }
            }
        ]
    },
    // 一级导航 - 归档
    {
        path: '/archive',
        name: 'Archive',
        component: () => import('../views/archive/ArchiveIndex.vue'),
        meta: { title: '归档' },
        children: [
            {
                path: '',
                name: 'ArchiveList',
                component: () => import('../views/page/Archive.vue'),
                meta: { title: '归档' }
            }
        ]
    },
    // 一级导航 - 标签云
    {
        path: '/tags',
        name: 'Tags',
        component: () => import('../views/tag/TagIndex.vue'),
        meta: { title: '标签' },
        children: [
            {
                path: '',
                name: 'TagCloud',
                component: () => import('../views/page/TagCloud.vue'),
                meta: { title: '标签云' }
            }
        ]
    },
    // 一级导航 - 关于
    {
        path: '/about',
        name: 'About',
        component: () => import('../views/about/AboutIndex.vue'),
        meta: { title: '关于' },
        children: [
            {
                path: '',
                name: 'AboutPage',
                component: () => import('../views/page/About.vue'),
                meta: { title: '关于我' }
            }
        ]
    },
    // 友情链接（独立页面）
    {
        path: '/links',
        name: 'Links',
        component: () => import('../views/page/Links.vue'),
        meta: { title: '友情链接' }
    },
    // 搜索页（由右上角放大镜入口进入）
    {
        path: '/search',
        name: 'Search',
        component: () => import('../views/search/SearchPage.vue'),
        meta: { title: '搜索' }
    },
    // 认证路由（不在顶部tab显示）
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/auth/Login.vue'),
        meta: { title: '登录' }
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('../views/auth/Register.vue'),
        meta: { title: '注册' }
    },
    // 一级导航 - 管理后台（仅登录后可见，包含二级子路由）
    {
        path: '/admin',
        name: 'Admin',
        component: () => import('../views/admin/AdminIndex.vue'),
        meta: { title: '管理后台', requiresAuth: true },
        redirect: '/admin/dashboard',
        children: [
            {
                path: 'dashboard',
                name: 'AdminDashboard',
                component: () => import('../views/admin/Dashboard.vue'),
                meta: { title: '控制台', requiresAuth: true }
            },
            {
                path: 'article',
                name: 'AdminArticle',
                component: () => import('../views/admin/ArticleManage.vue'),
                meta: { title: '文章管理', requiresAuth: true }
            },
            {
                path: 'article/create',
                name: 'AdminArticleCreate',
                component: () => import('../views/admin/ArticleEdit.vue'),
                meta: { title: '新建文章', requiresAuth: true }
            },
            {
                path: 'article/edit/:id',
                name: 'AdminArticleEdit',
                component: () => import('../views/admin/ArticleEdit.vue'),
                meta: { title: '编辑文章', requiresAuth: true }
            },
            {
                path: 'user',
                name: 'AdminUser',
                component: () => import('../views/admin/UserManage.vue'),
                meta: { title: '用户管理', requiresAuth: true }
            },
            {
                path: 'role',
                name: 'AdminRole',
                component: () => import('../views/admin/RoleManage.vue'),
                meta: { title: '角色管理', requiresAuth: true }
            },
            {
                path: 'permission',
                name: 'AdminPermission',
                component: () => import('../views/admin/PermissionManage.vue'),
                meta: { title: '权限管理', requiresAuth: true }
            },
            {
                path: 'comment',
                name: 'AdminComment',
                component: () => import('../views/admin/CommentManage.vue'),
                meta: { title: '评论管理', requiresAuth: true }
            },
            {
                path: 'media',
                name: 'AdminMedia',
                component: () => import('../views/admin/MediaManage.vue'),
                meta: { title: '媒体管理', requiresAuth: true }
            },
            {
                path: 'backup',
                name: 'AdminBackup',
                component: () => import('../views/admin/BackupManage.vue'),
                meta: { title: '备份恢复', requiresAuth: true }
            }
        ]
    },
    // 404页面
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('../views/shared/NotFound.vue'),
        meta: { title: '页面未找到' }
    }
];
// 根据环境自动选择base path
// 生产环境: /blog/
// 开发调试: /blog-dev/
const isProdRuntime = process.env.NODE_ENV === 'production' ||
    (typeof window !== 'undefined' && window.location.pathname.startsWith('/blog/'));
const basePath = isProdRuntime ? '/blog/' : '/blog-dev/';
const router = createRouter({
    history: createWebHistory(basePath),
    routes
});
// 路由守卫：需要认证的页面检查token
router.beforeEach((to, from, next) => {
    const requiresAuth = to.meta.requiresAuth;
    const token = localStorage.getItem('token');
    // 如果页面需要认证
    if (requiresAuth) {
        if (!token) {
            // 没有token，跳转到登录页
            next('/login');
        }
        else {
            next();
        }
    }
    else {
        // 如果已经登录了，访问登录/注册页跳转到首页
        if ((to.path === '/login' || to.path === '/register') && token) {
            next('/');
        }
        else {
            next();
        }
    }
});
export default router;
